var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "发券",
        visible: _vm.dialogVisible,
        width: "500px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.clearBeforeClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "100px", rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "发放对象", prop: "shopId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    remote: "",
                    placeholder: "请输入客户名称",
                    filterable: "",
                    "reserve-keyword": "",
                    "remote-method": _vm.remoteMethodForMerchant,
                    loading: _vm.loadingForMerchant,
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.shopId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "shopId", $$v)
                    },
                    expression: "form.shopId",
                  },
                },
                _vm._l(_vm.optionsForMerchant, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: `${item.provinceName || ""}/${
                        item.cityName || ""
                      }/${item.areaName || ""}/${item.shopName}`,
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "发券数量", prop: "numbers" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入发券数量",
                  type: "number",
                  min: "1",
                },
                model: {
                  value: _vm.form.numbers,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "numbers", _vm._n($$v))
                  },
                  expression: "form.numbers",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }